import {
  PROFILE_KEY,
  updateProfileAction
} from '@gymaholic/packages'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'

const ACTION_TYPE = {
  UPDATE_WORKOUT_DURATION_GOAL: 'UPDATE_WORKOUT_DURATION_GOAL'
}

export function updateWorkoutDurationGoalProfileAction (value) {
  return updateProfileAction({
    type: getActionStrReduxUtil(ACTION_TYPE.UPDATE_WORKOUT_DURATION_GOAL, value),
    payload: {
      key: PROFILE_KEY.WORKOUT_DURATION_GOAL,
      value
    }
  })
}
